import { edenredUserManager } from './edenredUserManager';
import { routeStorage } from '../../routes/routeStorage';
import { BackendErrors } from '../../models';
import { REDIRECT_FROM_AUTH_SERVER_ROUTE } from '../../routes/routes';
import { ExternalAuthSources } from '../../pages/RedirectPage';

export const handleExternalLogin = async (): Promise<void> => {
  const url = new URL(window.location.href);

  if (url.pathname !== REDIRECT_FROM_AUTH_SERVER_ROUTE) return;

  const source = url.searchParams.get('source') as ExternalAuthSources | null;

  if (source !== ExternalAuthSources.EDENRED) return;

  await edenredUserManager
    .signinRedirectCallback()
    .then(() => {
      routeStorage.clearExternalLoginError();
    })
    .catch(() => {
      routeStorage.saveExternalLoginError(BackendErrors.EXTERNAL_LOGIN_ERROR);
    });
};
